<ng-container *ngIf="photo; else photoPlaceholder">
	<button
		*ngIf="photoUrl; else photoPending"
		type="button"
		class="order-line-photo-thumb"
		(click)="view.emit()"
		pTooltip="View photo"
		tooltipPosition="top"
		[attr.aria-label]="'View photo ' + photo.file_name"
	>
		<img [src]="photoUrl" [alt]="photo.file_name" />
		<span class="order-line-photo-thumb-overlay">
			<i class="pi pi-search-plus"></i>
		</span>
	</button>
	<ng-template #photoPending>
		<div class="order-line-photo-placeholder order-line-photo-placeholder--generic">
			<i class="pi pi-spin pi-spinner text-500"></i>
		</div>
	</ng-template>
</ng-container>
<ng-template #photoPlaceholder>
	<div
		class="order-line-photo-placeholder"
		[ngClass]="isGeneric ? 'order-line-photo-placeholder--generic' : 'order-line-photo-placeholder--missing'"
	>
		<i class="pi text-500" [ngClass]="isGeneric ? 'pi-ban' : 'pi-image'"></i>
	</div>
</ng-template>
